import { Role } from '__generated__/GQL';
import getProofOfFundsStatus from 'features/Onboarding/modules/CapitalDepositProofOfFunds/libs/getProofOfFundsStatus';

import { State } from '../../machine';
import model from '../../machine/model';
import locales from './locales';
import { GetVerificationStep, VerificationStatus } from './types';

const getProofOfFundsStep: GetVerificationStep = ({ verificationData }) => {
  const { company, companyUser } = verificationData.viewer;

  const status = getProofOfFundsStatus({
    company,
    isAccountHolder: companyUser.roles.includes(Role.AccountHolder),
    kybDocuments: company.kybDocuments ?? [],
    lastKybReview: company.lastKybReview,
    legalShareCapital: company.profile.legalShareCapital,
  });

  return {
    errors: [],
    id: State.PROOF_OF_FUNDS,
    metadata: {
      event: model.events.GO_PROOF_OF_FUNDS(),
      iconName: 'wallet',
      isDisabled: status === VerificationStatus.Validated,
      label: locales.proofOfFunds,
    },
    status,
  };
};

export default getProofOfFundsStep;
